const Data = [
  {
    id: 1,
    title: "Mount Fuji",
    locationUrl: "location.png",
    location: "Japan",
    googleMapsUrl: "https://goo.gl/maps/1DGM5WrWnATgkSNB8",
    startDate: "12 Jan, 2021",
    endDate: "24 Jan, 2021",
    description:
      "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists.",
    imageUrl: "mount-fuji.png",
  },
  {
    id: 2,
    title: "Sydney Opera House",
    locationUrl: "location.png",
    location: "AUSTRALIA",
    googleMapsUrl: "https://goo.gl/maps/QJU9zk1Zh32Lboea7 ",
    startDate: "27 May, 2021",
    endDate: "8 Jun, 2021",
    description:
      "The Sydney Opera House is a multi-venue performing arts centre in Sydney. Located on the banks of the Sydney Harbour, it is often regarded as one of the 20th century's most famous and distinctive buildings.",
    imageUrl: "sydney.png",
  },
  {
    id: 3,
    title: "Geirangerfjord",
    locationUrl: "location.png",
    location: "NORWAY",
    googleMapsUrl: "https://goo.gl/maps/Zksttm6cX9FQchiKA",
    startDate: "01 Oct, 2021",
    endDate: "18 Nov, 2021",
    description:
      "The Geiranger Fjord is a fjord in the Sunnmøre region of Møre og Romsdal county, Norway. It is located entirely in the Stranda Municipality.",
    imageUrl: "fjord.png ",
  },
];
export default Data;